import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import React from 'react';

export default function SKModal({
  isOpen,
  onClose,
  title,
  footer,
  children,
  ...rest
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...rest}>
      <ModalOverlay />
      <ModalContent bg="#ffe7d5">
        {title && <ModalHeader color="black">{title}</ModalHeader>}
        <ModalCloseButton color="#053c34" />
        <ModalBody>{children}</ModalBody>

        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
}
